import express, { Router } from 'express';

import * as activityValidation from './activity.validation';
import * as activityController from './activity.controller';

import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { AuditMode } from '@/shared/constants/enum.constant';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import validate from '@/shared/utils/middlewares/validate.middleware';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(),
    validate(activityValidation.getActivities),
    activityController.getActivities,
  )
  .post(
    userAuthAndCheckPermissions(),
    validate(activityValidation.createActivity()),
    setAuditFields({ mode: AuditMode.CREATE }),
    activityController.createActivity,
  );

router
  .route('/public')
  .post(
    validate(activityValidation.createActivity()),
    setAuditFields({ mode: AuditMode.CREATE }),
    activityController.createActivity,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(),
    validate(activityValidation.getActivityById),
    activityController.getActivityById,
  )
  .patch(
    userAuthAndCheckPermissions(),
    validate(activityValidation.updateActivity()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    activityController.updateActivity,
  );

export default router;
